// extracted by mini-css-extract-plugin
module.exports = {"navbar":"navbar_navbar__oVzOs","link":"navbar_link__3oEGV","linkActive":"navbar_linkActive__1AbPp","logo":"navbar_logo__srP46"};